// Copyright (c) 2017 Deere & Company

import ProductsByCustomer from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.productsByCustomer,
    exportToExcel: state.exportToExcel,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ProductsByCustomer);



// WEBPACK FOOTER //
// ./src/product/products-by-customer/state-connector.js